import React from "react";
import MagreachIcon from "../icons/MagreachIcon";
import Container from "./Container";
import { CloudSoft } from "../characters/Clouds";
import { Pip } from "../characters/Character";
import { useI18n } from "../../i18n/I18nProvider";

const Footer = () => {
  const { t } = useI18n();
  const columns = [
    {
      title: t("footer.product"),
      links: [
        { name: t("footer.calendar"), href: "#calendar" },
        { name: t("footer.rates"), href: "#rates" },
        { name: t("footer.desks"), href: "#desks" },
      ],
    },
    {
      title: t("footer.company"),
      links: [
        { name: t("nav.login"), href: "https://me.influ8.app" },
        { name: t("cta.advertiser"), href: "https://dashboard.influ8.app" },
      ],
    },
    {
      title: t("footer.resources"),
      links: [{ name: t("footer.questions"), href: "#faq" }],
    },
  ];

  return (
    <footer className="relative overflow-hidden border-t border-hairline bg-paper">
      <Container className="grid gap-10 py-12 md:grid-cols-[minmax(0,1.2fr)_repeat(3,minmax(0,0.7fr))]">
        <div>
          <div className="mb-3 flex items-center gap-2">
            <MagreachIcon width={32} height={32} />
            <span className="text-subheading font-semibold tracking-wide">{t("brand")}</span>
          </div>
          <p className="max-w-sm text-body text-mid-gray">{t("footer.aboutBody")}</p>
          <Pip icon size={56} decorative className="mt-4" />
        </div>
        {columns.map((column) => (
          <div key={column.title}>
            <p className="text-body font-semibold text-ink">{column.title}</p>
            <ul className="m-0 mt-3 flex flex-col gap-2 p-0">
              {column.links.map((link) => (
                <li key={link.name} className="list-none">
                  <a
                    href={link.href}
                    className="inline-flex min-h-11 items-center text-body text-mid-gray no-underline hover:text-ink"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </Container>
      <CloudSoft className="pointer-events-none absolute -right-8 bottom-8 hidden w-40 text-lilac md:block" />
      <div className="border-t border-hairline">
        <Container className="py-4">
          <p className="text-body text-mid-gray">{t("footer.copy")}</p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
